import React from "react";
import ReactDOMServer from "react-dom/server";
import { Marker } from "react-leaflet";
import { divIcon } from "leaflet";
import { IHotelMapMarkerProps } from "./HotelMapMarkerProps";
import { StyledSpinner } from "./HotelMapMarkerHelpers";
import { useHotelRates } from "../../../hooks/useHotelRates";
import { priceFormatter, isBrowser } from "../../../utils/helpers";

const HotelMapMarker: React.FC<IHotelMapMarkerProps> = ({
  hotel,
  priceFilter,
  className,
  onMarkerClick,
  onRateLoad,
}) => {
  const [isLoadingRates, selectedRoom] = useHotelRates(hotel);
  const currency = hotel.currency;
  let priceClass = "no-price-filter";

  if (
    selectedRoom !== null &&
    priceFilter !== "undefined" &&
    priceFilter !== null
  ) {
    if (priceFilter === "under_50" && selectedRoom.FromRate > 50) {
      priceClass = "filtered-by-price";
    } else if (
      priceFilter === "between_50_100" &&
      (selectedRoom.FromRate < 50 || selectedRoom.FromRate > 100)
    ) {
      priceClass = "filtered-by-price";
    } else if (priceFilter === "over_100" && selectedRoom.FromRate < 100) {
      priceClass = "filtered-by-price";
    }
  } else if (
    priceFilter !== "undefined" &&
    priceFilter !== null &&
    selectedRoom === null &&
    priceFilter !== "show_all"
  ) {
    priceClass = "filtered-by-price";
  }

  React.useEffect(() => {
    if (isLoadingRates === false) {
      onRateLoad && onRateLoad();
    }
  }, [isLoadingRates]);

  const HotelPrice = (props: { price: number | null }) => {
    return (
      <span className="price">
        {props.price
          ? `${priceFormatter(props.price, 0, currency)}`
          : "Sold Out"}
      </span>
    );
  };

  const HotelMapIcon = ({ isLoadingRates, hotel }: any) => {
    return (
      <>
        {isLoadingRates ? (
          <StyledSpinner />
        ) : process.env.GATSBY_SHOW_MEMEBER_RATE_LABEL === "true" ? (
          <HotelPrice price={hotel.bestPrice} />
        ) : (
          <HotelPrice price={hotel.displayPrice} />
        )}
        <div>
          <img src={hotel.brand.logoUrl} alt={hotel.name} />
        </div>
      </>
    );
  };

  const coordinates = [hotel.coordinates.latitude, hotel.coordinates.longitude];
  const customIcon = new divIcon({
    className: `hotel-icon ${priceClass} ${className}`,
    html: ReactDOMServer.renderToString(
      <HotelMapIcon isLoadingRates={isLoadingRates} hotel={hotel} />
    ),
  });

  return isBrowser ? (
    <Marker
      key={`marker-${hotel.crs_code}`}
      position={coordinates}
      icon={customIcon}
      eventHandlers={{
        click: onMarkerClick,
      }}
      data={hotel}
    />
  ) : null;
};

export default HotelMapMarker;
